/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ModelQuantityAnalysis {
  angular.module("meevo.plugins.modelQuantityAnalysis", []);
}
